<template>
  <div class="loginContainer">
    <div class="loginModule flex-center">
      <div class="unitBackground"></div>
      <div class="unit">
        <div class="loginUnit">
          <div class="topTitle space-around">
            <div href="#login" class="weui-navbar__item weui-bar__item_on" data-id="1">
              <div>登录</div>
            </div>
            <div href="#register" class="weui-navbar__item" data-id="2">
              <div>注册</div>
            </div>
            <div class="underframe"></div>
          </div>
          <div class="weui-tab__panel">
            <div class="weui-tab__content" id="login" style="display: block;">
              <form action="" method="post">
                <div>
                  <input type="text" onkeyup="value=value.replace(/[^\d]/g,'')" oninput="if(value.length>11)value=value.slice(0,11)" placeholder="请输入手机号码" class="account" />
                  <img src="../../static/images/dutyInsurance/login/cancel.png" alt="" class="cancel" />
                </div>
                <div>
                  <input type="password" onKeyUp="value=value.replace(/[\W]/g,'')" placeholder="请输入长度8-16位密码" class="password" />
                  <img src="../../static/images/dutyInsurance/login/closeEyes.png" alt="" class="showPassword" />
                </div>
                <div class="passwordPrompt">*密码须包含数字、字母2种元素</div>
                <!--<div class="verification">
                    <input type="text" onkeyup="value=value.replace(/[^\d]/g,'')" oninput="if(value.length>6)value=value.slice(0,6)" placeholder="输入 6 位短信验证码" class="code" />
                    <button class="codeBtn" type="button" value="59s" data-name="#login" data-type="1">获取验证码</button>
                </div>-->
                <button type="button" class="forgetPassword" >忘记密码 | 修改密码</button>
                <button class="loginButton" type="submit" onmouseover="this.style.backgroundColor='#ff8a73';" onmouseout="this.style.backgroundColor='#ff7052';" onmouseup="this.style.backgroundColor='#d95e45';">登录</button>
              </form>
            </div>
            <div class="weui-tab__content" id="register">
              <form action="" method="post">
                <div>
                  <input type="text" onkeyup="value=value.replace(/[^\d]/g,'')" oninput="if(value.length>11)value=value.slice(0,11)" placeholder="请输入手机号码" class="account" />
                  <img src="../../static/images/dutyInsurance/login/cancel.png" alt="" class="cancel" />
                </div>
                <div>
                  <input type="text" onkeyup="value=value.replace(/[^\d]/g,'')" oninput="if(value.length>6)value=value.slice(0,6)" placeholder="输入 6 位短信验证码" class="code" />
                  <button class="codeBtn" type="button" value="59s" data-name="#register" data-type="2">获取验证码</button>
                </div>
                <div>
                  <input type="password" onKeyUp="value=value.replace(/[\W]/g,'')" placeholder="请输入长度8-16位密码" class="password" />
                  <img src="../../static/images/dutyInsurance/login/closeEyes.png" alt="" class="showPassword" />
                </div>
                <div class="passwordPrompt">*密码须包含数字、字母2种元素</div>
                <p class="protocol">
                                    <span class="check_box whetherAgree">
                                        <img class="checkbox" src="../../static/images/dutyInsurance/login/checkbox_no.png" data-check="0">
                                        <img class="checkbox isCheck" src="../../static/images/dutyInsurance/login/checkbox_yes.png" data-check="1" style="display: none;">
                                    </span>
                  <span>我已阅读</span>
                  <span class="registrationProtocol">《小白保险会员注册协议》</span>
                </p>
                <button class="register" type="submit" onmouseover="this.style.backgroundColor='#ff8a73';" onmouseout="this.style.backgroundColor='#ff7052';" onmouseup="this.style.backgroundColor='#d95e45';">注册</button>
              </form>
            </div>
          </div>
        </div>
        <div class="forgetPasswordUnit">
          <div id="forgetPassword">
            <form action="" method="post">
              <div class="forgetPasswordTitle">找回密码 | 修改密码</div>
              <div>
                <input type="text" onkeyup="value=value.replace(/[^\d]/g,'')" oninput="if(value.length>11)value=value.slice(0,11)" placeholder="请输入手机号码" class="account" />
                <img src="../../static/images/dutyInsurance/login/cancel.png" alt="" class="cancel" />
              </div>
              <div>
                <input type="text" onkeyup="value=value.replace(/[^\d]/g,'')" oninput="if(value.length>6)value=value.slice(0,6)" placeholder="输入 6 位短信验证码" class="code" />
                <button class="codeBtn" type="button" value="59s" data-name="#forgetPassword" data-type="3">获取验证码</button>
              </div>
              <div>
                <input type="password" onKeyUp="value=value.replace(/[\W]/g,'')" placeholder="请输入长度8-16位新密码" class="newPassword" />
                <img src="../../static/images/dutyInsurance/login/closeEyes.png" alt="" class="showPassword" />
              </div>
              <div>
                <input type="password" onKeyUp="value=value.replace(/[\W]/g,'')" placeholder="请再次输入新密码" class="confirmPassword" />
                <img src="../../static/images/dutyInsurance/login/closeEyes.png" alt="" class="showPassword" />
              </div>
              <div class="passwordPrompt">*密码须包含数字、字母2种元素</div>
              <div class="space-around">
                <button class="backLogin" type="button" onmouseover="this.style.backgroundColor='#eff1f5';" onmouseout="this.style.backgroundColor='#ececec';" onmouseup="this.style.backgroundColor='#f2f7fe';">返回登录</button>
                <button class="confirmModification" type="submit" onmouseover="this.style.backgroundColor='#ff8a73';" onmouseout="this.style.backgroundColor='#ff7052';" onmouseup="this.style.backgroundColor='#d95e45';">确认修改</button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
    <div class="prompt" hidden>
      <div class="shadow"></div>
      <div class="promptContainer">
        <!--标题-->
        <div class="promptTitle">小白宝会员注册协议</div>
        <div class="promptContent">
          <div class="customerNotificationDetails">
            <br />
            本服务协议是正迅保险经纪有限公司（下称“我们”或“运营方”）与注册用户关于使用“小白宝”APP（下称“小白宝”）所订立的协议，请您仔细阅读。一旦您勾选“我已经认真阅读并同意《小白宝会员服务协议》”、点击“同意"按钮，并注册成为小白宝的注册用户，意味着您对本协议的所有条款均已知晓、理解并接受，协议即开始生效。此后，您不得以未阅读本协议的内容提出异议。若您不接受以下条款，请立即停止注册或主动停止使用小白宝的产品及服务。
            <br /><br />
            本协议内容包括本协议正文所载之各条款及我们已经发布的或将来可能发布的各类协议、规则（以下统称“规则”）；所有该等规则均为本协议不可分割的一部分，与本协议正文具有同等法律效力。在您注册成为小白宝的用户时，您已经阅读、理解并接受本协议正文的全部条款及规则，并承诺阅读、理解并接受在您注册成为小白宝的用户后我们不时发布的规则；您同意遵守中国的各类法律、法规及规范性文件的规定，如有违反而导致任何法律后果的发生，您应以自己的名义独立承担所有相应的法律责任。
            <br /><br />
            <div class="caption_1">一、会员须知</div>
            <div>1.注册者资格</div>
            您确认，在您完成注册程序或使用小白宝服务时，您应当是具备完全民事权利能力及民事行为能力的自然人。如您违反前述注册限制注册了账户并使用了小白宝的产品及服务，我们有权随时中止或终止您的会员资格，并要求您或您的监护人承担相应的责任。您可以使用小白宝认可的第三方账户直接登录小白宝网站并自动成为小白宝会员，但在接受或购买小白宝产品或服务时，您可能需要提供法律法规或届时的规则要求的必要身份信息及资料。
            <br /><br />
            <div>2.用户信息</div>
            a)：在进行注册、激活或验证流程时，您应当按照相应页面的提示提供您的身份信息及资料，并确保该等身份信息及资料的真实、及时、完整和准确。
            <br />
            b)：当您的身份信息及资料发生变化时，您应当及时更新井准确提供您的身份信息及资料。
            <br /><br />
            <div >3.账户安全</div>
            a)您应对您在小白宝的登录名和密码保密，且须对您在该登录名和密码下发生的所有活动(包括但不限于发布信息、网上点击同意或提交购买、接受各类产品或服务等)承担责任。您应对小白宝的产品及服务中的内容自行加以判断，并承担因使用内容而引起的所有风险，包括因对内容的正确性、完整性或实用性的依赖而产生的风险。我们不对因前述风险而导致的任何损失或损害承担责任。
            <br />
            b)您了解并同意：如发现任何人未经授权使用您的小白宝登录名和密码，您应当立即通知小白宝，授权小白宝经过必要身份识别措施后更改密码或作岀其他应对措施。但小白宝不会对因您未能遵守本款规定而发生的任何损失负责。
            <br /><br />
            <div >4.账户管理：除非有法律规定或司法裁判，否则您的登录名和密码不得以任何方式转让、贈与或继承。您不得以借用、租用或其他任何方式将账户提供给第三方使用。小白宝在此郑重提醒您，无论是您还是您的代理人或其他第三方（包括但不限于您的小白宝登录信息、登录验证信息泄露导致），以您的小白宝登录信息和登录验证信息登录小白宝后在小白宝的一切行为和言论均视为您本人的行为，并应由您承担相应的法律后果。</div>
            <br />
            <div >
              5. 您成功注册后，您可以自行或授权您的代理人根据小白宝的相关规则，通过小白宝以【点击确认、同意或电子签章】的方式签署有关法律文件，经运营方审核通过后为您的提供相应服务。详细操作规则及方式请见有关法律文件和小白宝所发布的规则。您应当审慎并独立地对相关信息进行判断并作出决策。您使用小白宝的服务进行操作、交易而产生的风险、损失，均由您自行承担。
            </div>
            <br />
            <div >
              6.我们不保证您的需求一定能够得到满足；若您的需求无法得到满足的，运营方不对由此导致的您的任何损失承担任何责任。
            </div>
            <br />
            <div class="caption_1">二、会员的权利和义务</div>
            <div >1：在遵守本服务协议的前提下，您将享有小白宝提供的会员服务，并将收到小白宝最新的优惠产品和服务的相关信息。</div>
            <br />
            <div >2.：如您不愿意接受小白宝的信息，您有权要求小白宝停止向您发送产品和服务信息；</div>
            <br />
            <div >3：在小白宝网站上使用小白宝服务过程中，您承诺遵守以下约定：</div>
            a)在使用小白宝服务过程中所有行为均遵守囯家法律、法规等规范性文件，不违背社会公共利益或公共道德，不损害他人合法权益，不违反本协议；
            <br />
            b)在未经小白宝事先书面同意的情况下，不以复制、传播等任何方式使用小白宝网站上展示的资料、信息或数据。
            <br /><br />
            <div >4.您了解并同意：</div>
            a)对于您在小白宝上发布的涉嫌违法或涉嫌侵犯他人合法权利或违反本协议的信息小白宝有权不经通知您即予以删除、屏蔽或断开相关的信息链接；同时，运营方有权视您的行为性质，采取包括但不限于暂停或终止本服务、追究法律责任等措施。运营方有权判断用户的行为是否符合小白宝服务条款规定的权利，如果运营方认为用户违背了本协议、法律法规政策等规定，运营方有权随时变更、中断或终止部分或全部服务的权利，且无需事先告知。
            <br />
            b)对于您涉嫌违反承诺的行为对我们或任意第三方造成损害的，您均应当以自己的名义独立承担所有的法律责任。
            <br /><br />
            <div >5：在何种情况下，小白宝均不对由于信息网络正常的设备维护，信息网络连接故障，电脑、通讯或其他系统的故障，电力故障，罢工，暴乱，起义，骚乱，火灾，洪水，风暴，爆炸，战争，政府行为，司法行政机关的命令或第三方的不作为而造成的不能服务或延迟服务承担责任；</div>
            <br />
            <div >6：为了提高服务质量，小白宝可能暂停服务以调整或升级系统，小白宝需在网站公告暂停服务时间。在任何情况下，小白宝无须为暂停会员服务承担违约责责任</div>
            <br />
            <div class="caption_1">三、服务协议的修改、中止、终止和账户注销</div>
            <div >
              1.您了解并同意：小白宝在法律环境变化或业务发展需要时可能对本服务协议所做的修改，本服务协议如发生任何变动，小白宝将在网站上公示变动内容。您应不时地注意本协议正文各条款及小白宝所发布规则的变更，若您在本协议正文相关条款和/或小白宝所发布规则内容公告变更后继续使用小白宝的，表示您已充分阅读、理解并接受修改后的内容，也将遵循修改后的本协议正文条款和/或小白宝所发布规则使用小白宝。如您不同意相应修改的，可以选择注销您的小白宝会员账户，或停止使用小白宝的产品及服务。
            </div>
            <br />
            <div >
              2.您同意，出现以下情况时，小白宝有权不经事先通知地中止、终止向您提供部分或全部小白宝的会员服务，并注销您的账户(小白宝会员资格)，且无须为此向您或任何第方承担任何责任
            </div>
            a.您在使用小白宝服务期间存在违法行为或违反本协议
            <br />
            b.您提供的个人身份信息虚假或不真实或不完整或过期无效的
            <br />
            c.以他人名义注册为小白宝会员的
            <br />
            d.未经有效许可使用他人银行账户进行支付的
            <br />
            e.经证实用户为政府部门发布的恐怖分子或被列入其他黑名单
            <br />
            f.存在其他违反诚实信用或欺诈行为的
            <br />
            g.本协议变更时，您明示并通知小白宝不愿接受新的服务协议的
            <br />
            h.如您连续三年未登录过小白宝，您的小白宝会员资格可能被注销
            <br /><br />
            <div >
              3、您同意并确认：您的小白宝账户的暂停、中断或终止不代表您责任的终止，您仍应继续履行您使用小白宝服务期间所签署之各项法律文件（包括但不限于本协议、对应的交易文件）项下未履行完毕之义务，并对您使用小白宝服务期间的行为承担可能的违约或损害赔偿责任；此外，在该等情况下，小白宝仍可保存您的个人信息和资料并根据本协议规定予以使用和披露。
            </div>
            <br />
            <div class="caption_1">四、隐私政策</div>
            <div>
              我们重视用户的隐私，并尽全力保护您的个人信息安全。关于小白宝适用的隐私政策，请您点击<span id="privacyPolicy">《隐私政策》</span>”进行访问并仔细阅读。我们承诺会对您的个人信息和其他数据进行严格保密，确保您的个人信息安全。
            </div>
            <br />
            <div class="caption_1">五、电子合同</div>
            <div >
              1、您在小白宝所订立的法律文件均采用电子方式订立，您可以采用点击确认、同意、电子签名等方式签署相关法律文件，具体签署方式以小白宝届时支持的方式为准，各种签署方式具有同等法律效力，您不得以签署方式不同为由，否认相关法律文件的法律效力。每一份法律文件可以有多份副本，并且每份副本均具有同等法律效力。
            </div>
            <br />
            <div >
              2、无论是否是您本人亲自进行的操作，在小白宝生成了与您在小白宝账户对应之唯一登录信息（包括但不限于绑定手机号码、绑定邮箱、昵称、ID等，以小白宝不时要求为准）、您设置了对应的登录密码或使用了小白宝向您的绑定手机号码发送的短信验证码（以下统称“登录验证信息”）并对您提供的身份证件信息进行验证后，任何人通过您的账户之登录信息和登录验证信息登录进入您的小白宝账户后，在小白宝通过点击确认方式签署的电子法律文件，以及您自行或委托第三方使用您的电子签名签署的电子法律文件，均视为您本人的真实意思表示和您本人的行为，一经成立生效即不可撤销，且对您具有法律约束力并产生可强制执行的效力。
            </div>
            <br />
            <div >
              3、您根据本协议以及小白宝的相关规则以电子方式签署相应的法律文件后，非经法定或约定的方式和程序，不得擅自修改。小白宝向您提供该等法律文件的保管、查询、核对等服务，如您对该等法律文件的真伪或内容有任何疑问，您可通过小白宝的相关系统板块查阅并进行核对。如您经查询仍对法律文件的真伪、版本有任何争议，应以小白宝记录为准。
            </div>
            <br />
            <div class="caption_1">六、通知</div>
            <div>
              所有发给您的通知都可通过您在小白宝预留的通讯方式，以电子邮件、常规的信件或在网站显著位置公告的等方式进行传送。我们将通过上述方法之一将消息传递给您，告知您服务条款的修改、服务变更、或其它重要事情。
            </div>
            <br />
            <div class="caption_1">七、法律适用、管辖与其他</div>
            <div >1.本协议适用中华人民共和国大陆地区法律。</div>
            <br />
            <div >2.如因本协议产生之争议，您同意以广州市黄埔区人民法院为第一审管辖法院。</div>
            <br />
            <div >3.本协议包含了您成为小白宝会员所需要了解并遵守的协议条款，您在购买或接受小白宝某保险产品或服务时还需要了解并签署该特定产品或服务的条款或具体约定(请参见您接受该产品或服务时签署的其他协议)。如本服务协议与具体产品或服务协议有不一致之处，以具体产品或服务的协议为准。</div>
            <br /><br />
            <div>注：本免责声明与中华人民共和国法律解析一致，包括法律条款中有争议抵触的内容，您和正迅保险经纪有限公司一致同意服从法院的管辖。若有任何服务条款与法律相抵触，那这些条款将按尽可能接近的方法重新解析，而其它条款则保持对用户产生法律效力和影响。</div>
            <div >本协议签订地址：广州</div>
            <br /><br />
          </div>
        </div>
        <div class="button">
          <button>
            <span>我已阅读此协议</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script type="text/javascript">
  import gt from "../tool/geetest/gt.js";
  // import Axios from "axios";
  export default {
    name: "login",
    data() {
      return {
        name: '',
        returnUrl: null,
        startTime: null,
        type: null,        // 1：登录、2：注册、3：忘记密码
        account: null,
        that: null,
      }
    },
    methods:{
      //-- 事件绑定
      eventBinding() {
        let that = this;

        //-- 浏览 注册协议
        $(".registrationProtocol").on("click", function () {
          $('.prompt').show().removeAttr("hidden");
          $('body').addClass('overflowHidden');
        });

        //-- 关闭提示弹窗
        $('.promptContainer .button button').on("click", function () {
          $('.prompt').hide();
          $('body').removeClass('overflowHidden');
          if ('none' === $(".whetherAgree>.checkbox.isCheck").css('display')) {
            checkboxClick($(".whetherAgree>.checkbox")[0]);
          }
        });

        $("#privacyPolicy").on("click", function () {
          location.href = "https://pic.xiaobaibao.com/system/reportTemp/2020/2/1e97d731774e48f7aa36bcbdc16b0ef0.pdf";
        });

        //-- 是否同意 -> 注册协议
        $(".whetherAgree>.checkbox").on("click", function(){
          checkboxClick(this);
        });

        function checkboxClick(_this) {
          $(_this).hide();

          const isCheckEle = $(_this).hasClass("isCheck"),
            hideStyle = {display: "inline"};

          isCheckEle ? $(_this).prev().css(hideStyle) : $(_this).next().css(hideStyle);
        }

        //-- 清空手机号
        $(".cancel").on("click", function() {
          $(this).siblings('input').val("");
        });

        //-- 显示密码
        $(".showPassword").on("click", function() {
          const $pwd = $(this).siblings('input');
          if($pwd.attr("type") == "password"){
            $pwd.attr('type','text');
            $(this).attr("src",'../../images/dutyInsurance/login/eyes.png');
          }else{
            $pwd.attr('type','password');
            $(this).attr("src",'../../images/dutyInsurance/login/closeEyes.png');
          }
        });

        //-- 忘记密码
        $(".forgetPassword").on("click", function() {
          $(".forgetPasswordUnit").css('width', '26rem');
          $('#login').hide();
        });

        //-- 注册
        $(".register").on("click", function (e) {
          e.preventDefault();

          const errorMsg = that.validationForm($("#register"), 2);
          if(that.$$.isValidObj(errorMsg)) return that.$message.error(errorMsg);

          that.userRegister();
        });

        //-- 返回登录
        $(".backLogin").on("click", function() {
          $(".forgetPasswordUnit").css('width', '0px');
          $('#login').show();
        });

        //-- 找回密码 | 修改密码 - 确认修改
        $(".confirmModification").on("click", function(e) {
          e.preventDefault();

          //-- check form
          const errorMsg = that.validationForm($("#forgetPassword"), 3);
          if(that.$$.isValidObj(errorMsg)) return that.$message.error(errorMsg);

          that.forgetPassword();
        });

        //-- 登录
        $(".loginButton").off().on("click", function (e) {
          e.preventDefault();

          let accountValue = aesMinEncrypt($("#login .account").val());
          let password = aesMinEncrypt($("#login .password").val());

          //-- 校验
          const errorMsg = that.validationForm($("#login"), 1);
          if(that.$$.isValidObj(errorMsg)) return that.$message.error(errorMsg);

          //-- 错误一次后 - 图形验证
          const verify = localStorage.getItem('loginFailed');
          console.log(verify);
          if (verify == "true") {
            that.type = 1;
            that.account = null;
            // 调用之前先通过前端表单校验
            return that.geeTestInit();
          }

          that.login(accountValue, password, 1, 1);
        });

        $(".codeBtn").off().on("click", function (e) {
          e.preventDefault();
          let dataType = $(this).attr('data-type'),
            thatName = $($(this).attr('data-name')),
            accountValue = thatName.find('.account').val();

          const errorMsg = that.validationForm_phone(thatName);
          if(errorMsg != null) return that.$message.error(errorMsg);

          that.type = parseInt(dataType);
          that.account = accountValue;
          that.that = $(this);
          that.geeTestInit();
        });

        //-- 主题切换
        $('.weui-navbar__item').on('click', function () {
          const dataId = $(this).attr('data-id');
          $(this).addClass('weui-bar__item_on').siblings('.weui-bar__item_on').removeClass('weui-bar__item_on');
          $('.underframe').css('left', dataId == '1' ? '10%':'60%');
          $($(this).attr("href")).show().siblings('.weui-tab__content').hide();
        });
      },

      //-- 验证表单
      validationForm(that, state){
        const passwordReg = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,16}$/;
        const passwordReg1 = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{8,16}$/;
        //-- check form
        const errorMsg = this.validationForm_phone(that);
        if(errorMsg != null) return errorMsg;

        switch (state) {
          case 1:{
            let password = that.find(".password").val().trim();

            if(!this.$$.isValidObj(password)) return "登录密码不能为空~";
            if(!passwordReg.test(password)) return "密码为8-16位，必须含数字、字母、符号至少2种或以上元素~";
            break;
          }
          case 2:{
            let password = that.find(".password").val().trim(),
              codeValue = that.find(".code").val().trim(),
              termsOfAgreement = that.find(".whetherAgree>.checkbox.isCheck").css("display");

            if(!this.$$.isValidObj(codeValue)) return "请输入验证码~";
            if(!this.$$.isValidObj(password)) return "登录密码不能为空~";
            if(!passwordReg1.test(password)) return "密码为8-16位，必须含数字、字母、符号至少2种或以上元素~";
            if(termsOfAgreement == "none") return "请阅读并同意《小白保险会员注册协议》";
            break;
          }
          case 3:{
            let newPassword = that.find(".newPassword").val().trim(),
              confirmPassword = that.find(".confirmPassword").val().trim();

            if(!this.$$.isValidObj(newPassword)) return "新密码不能为空~";
            if(!passwordReg1.test(newPassword)) return "新密码为8-16位，必须含数字、字母、符号至少2种或以上元素~";
            if(!this.$$.isValidObj(confirmPassword)) return "确认密码不能为空~";
            if (confirmPassword != newPassword) return "新密码和确认密码不一致~";
            break;
          }
        }
        return null;
      },
      //-- 验证手机号
      validationForm_phone(that){
        const accountValue = that.find(".account").val().trim();
        const phoneReg = /^0?(13[0-9]|14[0-9]|15[0-9]|16[0-9]|17[0-9]|18[0-9]|19[0-9])[0-9]{8}$/;

        if(!this.$$.isValidObj(accountValue)) return "请输入手机号~";
        if(!phoneReg.test(accountValue)) return "请输入有效手机号~";

        return null;
      },
      //-- 登录
      login(account, password, loginType = 1, terminal = 1, callback) {
        let that = this,
          params = {
            username: account,
            password: password,
            ltype: loginType,
            terminal: terminal
          };
        let loading = that.Loading.service({fullscreen: true});
        that.axios.post(that.UrlConfig.auth_member_accredit, params).then((response) => {
          let data = response.data;
          if (data.status == '1') {
            this.$confirm(response.data.message, '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning',
              center: true
            }).then(() => {
              $(".forgetPasswordUnit").css('width', '26rem');
              $('#login').hide();
            }).catch(() => {

            });
            //that.$message.error(response.data.message);
            that.$nextTick(() => loading.close());
          }else {
            if (data.status == '2'){
              that.$message.error(data.message);
              that.$nextTick(() => loading.close());
            }else {
              const token = data[that.$$.constant.tokenKey];
              that.$$.localStorageSet(that.$$.constant.tokenKey + '_TIMING', token);
              that.axios.defaults.headers.common[that.$$.constant.tokenKey] = token;
              that.$parent.getUserInfo();

              if (this.$$.isValidObj(that.returnUrl)){
                window.location.href = that.returnUrl;
              }else {
                that.$router.push({name: `index`});
              }
              that.$message.success("登录成功！");
              that.$nextTick(() => loading.close());
            }

          }
        }).catch(() => {
          that.$message.error("登录失败，请检查账号密码是否输入正确！");
          that.$nextTick(() => loading.close());
        });
        /*that.$$.request({
          url: that.UrlConfig.auth_member_accredit,
          pars: params,
          loading: true,
          sfn: function (data) {
            that.$$.closeLoading();
            if (data.success) {
              if ($.isEmptyObject(data.datas.list)) return $('.brokerList').html('');
              let {list, pagination} = data.datas;

              pagingData = {
                _pageSize: pagination.pageSize,
                _current: pagination.current,
                _total: pagination.total,
              };
              console.log(pagination)
              loadList(list);

              $(".pageLoading").remove();
            } else {
              $$.layerToast(data.msg);
            }
          },
          ffn: function (data) {
            that.$$.errorHandler();
          }
        });*/
      },
      //-- 注册
      userRegister() {
        let that = this,
          accountValue = aesMinEncrypt($("#register .account").val()),
          codeValue = $("#register .code").val(),
          passwordValue = aesMinEncrypt($("#register .password").val()),
          terminal = 1;

        const params = {
          account: accountValue,
          password: passwordValue,
          validationCode: codeValue,
          terminal: terminal,
        };

        let loading = that.Loading.service({fullscreen: true});
        that.axios.post('/member/member/registerMember', params).then((response) => {
          that.$nextTick(() => loading.close());
          let data = response.data;

          if (data.success) {
            that.$message.success("注册成功");

            that.login(accountValue, passwordValue, 1, terminal);
          }else {
            that.$message.error(data.msg);
          }
        });
      },
      //-- 找回密码 | 修改密码
      forgetPassword() {
        let that = this;
        //let accountValue = aesMinEncrypt($("#login .account").val());
        //let password = aesMinEncrypt($("#login .password").val());
        const accountValue = aesMinEncrypt($("#forgetPassword .account").val());
        const codeValue = $("#forgetPassword .code").val();
        const passwordValue = aesMinEncrypt($("#forgetPassword .newPassword").val());

        let params = {
          account: accountValue,
          validationCode: codeValue,
          step: 1,
          newestPassword: passwordValue
        };

        changePassword(params, 1);

        //-- step: 1-验证验证码，2-修改密码
        function changePassword(params, step) {
          let loading = that.Loading.service({fullscreen: true});
          that.axios.post('/member/member/forgetPassword', params).then((response) => {
            that.$nextTick(() => loading.close());
            let data = response.data;

            if (data.success) {
              if (step == 1){
                const key = data.datas;
                if (that.$$.isValidObj(key)) {
                  params = {
                    account: accountValue,
                    newestPassword: passwordValue,
                    validationCode: key,
                    step: 2
                  };
                  changePassword(params, 2);
                }
              }
              if (step == 2){
                that.$message.success("密码修改成功");

                setTimeout(function(){
                  location.reload();
                }, 1000);
              }
            }else {
              that.$message.error(data.msg);
            }
          });
        }
      },
      //-- 图形验证初始化 API1
      geeTestInit(){
        let that = this;
        init();     // 初始化

        function init() {
          let loading = that.Loading.service({fullscreen: true});
          that.axios.get('/member/geetest/register').then((response) => {
            that.$nextTick(() => loading.close());
            let data = response.data;

            if (data.success) {
              const {gt, challenge, new_captcha, success, startTime} = data.datas;
              that.startTime = startTime;

              initGeetest({
                gt: gt,
                challenge: challenge,
                new_captcha: new_captcha,
                offline: !success,
                product: 'bind',
                width: '18.75rem',
              }, handler);
            }else {
              that.$message.error(data.msg);
            }
          });
        }
        function handler(captchaObj) {
          captchaObj.onReady(function () {
            $("#wait").hide();
            captchaObj.verify();
          }).onSuccess(function () {
            let result = captchaObj.getValidate();
            if (!result) return that.$message.error('请完成验证');

            let params = {
              geetest_challenge: result.geetest_challenge,
              geetest_validate: result.geetest_validate,
              geetest_seccode: result.geetest_seccode,
              phone: that.account,
              sendType: that.type,
              startTime: that.startTime,
            };

            validate(params);       // 验证 API2
          });
        }
        //-- API2
        function validate(params) {
          let loading = that.Loading.service({fullscreen: true});
          that.axios.post('/member/geetest/validate', params).then((response) => {
            that.$nextTick(() => loading.close());
            let data = response.data;

            if (data.success) {
              switch (that.type) {
                case 1:
                  const accountValue = $("#login .account").val();
                  const password = $("#login .password").val();

                  that.login(accountValue, password, 1, 1);
                  return;
                case 2:
                case 3:
                  that.resetTime(that.that);
                  return;
              }
            }else {
              that.$message.error(data.msg);
            }
          });
        }
      },
      //-- 验证码倒计时
      resetTime(e) {
        let second = 60;
        let timer = null;

        const timeFun = function(){
          second -= 1;
          if(second >0){
            $(e).attr("disabled", true).text(second + "s");
          }else{
            clearInterval(timer);

            $(e).attr("disabled", false).text("获取验证码");
          }
        };

        timeFun();
        timer = setInterval(function(){
          timeFun();
        },1000);
      },

    },
    mounted() {
      let mainHeight = $('html').height() - ($('header').height() + $('.loginStatus').height());
      $('.wrapper main .loginContainer').css('height', mainHeight-1);

      //-- 返回路径
      this.returnUrl = this.$route.query.returnUrl;

      this.eventBinding();    // 事件绑定
    }
  }

  /**
   * 密码加密
   */
  const CryptoJS = require('crypto-js');  //引用AES源码js
  function aesMinEncrypt(word){
    var _word = CryptoJS.enc.Utf8.parse(word),
      _key = CryptoJS.enc.Utf8.parse("ihaierForTodoKey"),
      _iv = CryptoJS.enc.Utf8.parse("ihaierForTodo_Iv");
    var encrypted = CryptoJS.AES.encrypt(_word, _key, {
      iv: _iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7
    });
    return encrypted.toString();
  }
</script>

<style scoped>
  @import "../../static/css/dutyInsurance/login.css";
</style>



// WEBPACK FOOTER //
// src/components/login.vue